import FileUploadIcon from "@rsuite/icons/FileUpload";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import moment from "moment";
import { useState } from "react";
import { useRecoilValue } from "recoil";
import { IconButton, Input, Message, SelectPicker, Uploader } from "rsuite";
import { APi } from "../../Api";
import { userAtom } from "../../Atoms/user.atom";
import Grid from "../../Components/Grid";
import Responsive from "../../Components/Responsive";
import { checkPurpose, checkStatus } from "../../Constants/types";
import format_number from "../../Helpers/number_formatter";
import TransactionModel from "../../Models/transactionModel";

function AddEditCheck({
  _setmodel,
  error,
  model,
  clients,
  banks,
  fetchBanks,
  loadingAttach,
  attachments,
  _delete,
  upload,
  inset,
}) {
  const [modelTransaction, setmodelTransaction] = useState(
    new TransactionModel()
  );
  const [loadingTransaction, setloadingTransaction] = useState(false);
  const [_error, seterror] = useState(false);
  const user = useRecoilValue(userAtom);
  const deleteAction = (id) => {
    if (user.checkoutId) {
      alert("Vous n'êtes pas autorisés !!!");
    } else {
      APi.createAPIEndpoint(APi.ENDPOINTS.Transaction)
        .delete(id)

        .then((res) => {
          _setmodel((prev) => {
            let transactions = [...prev.transactions];
            return {
              ...prev,
              transactions: transactions.filter((el) => el.id != id),
            };
          });
        })
        .catch((e) => seterror(e.Message));
    }
  };
  const fetchTransactionsByCheckId = () => {
    APi.createAPIEndpoint(
      APi.ENDPOINTS.Transaction + "/fetchTransactionsByCheckId/" + model.id
    )
      .fetchAll()
      .then((res) =>
        _setmodel((prev) => ({ ...prev, transactions: res.data }))
      );
  };
  const saveTransaction = () => {
    setloadingTransaction(true);
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction)
      .create({
        ...modelTransaction,
        debit: Number(modelTransaction.debit),
        designation: "Regrouppement chéque N°" + model.checkNumber,
        checkoutId: user.checkoutId ? user.checkoutId : model.checkoutId,
        checkId: model.id,
      })
      .then((res) => {
        setloadingTransaction(false);
        fetchTransactionsByCheckId();
      })
      .catch((e) => {
        seterror(e.Message);

        setloadingTransaction(false);
      });
  };
  return (
    <>
      <Responsive l={6} xl={6} className="p-5">
        <label>Numéro:</label>
        <Input
          maxlength="7"
          onChange={(number) => {
            _setmodel((prev) => {
              return { ...prev, number };
            });
          }}
          value={model.number}
        />
      </Responsive>
      <Responsive l={6} xl={6} className="p-5">
        <label>Status</label>
        <SelectPicker
          disabled={
            !model.id || (model.transactions && model.transactions.length)
          }
          searchable={false}
          data={checkStatus}
          block
          noSearch
          value={model.status}
          onSelect={(status) => {
            _setmodel((prev) => {
              return {
                ...prev,
                status,
                transactions:
                  prev.status != 8 && status == 8 ? [] : prev.transactions,
              };
            });
          }}
        />
      </Responsive>
      {model.status == 8 &&
        (loadingTransaction ? (
          <div>...Loading</div>
        ) : (
          <div
            style={{ background: "rgba(76,103,194,0.3)", borderRadius: "5px" }}
          >
            <Responsive m={4} l={4} xl={4} className="p-5">
              <label>Montant:</label>
              <Input
                value={modelTransaction.debit}
                onChange={(amount) => {
                  setmodelTransaction((prev) => ({
                    ...prev,
                    debit: parseFloat(amount),
                  }));
                }}
              />
            </Responsive>
            <Responsive m={4} l={4} xl={4} className="p-5">
              <label>Date:</label>
              <Input
                type="date"
                value={modelTransaction.date}
                onChange={(date) => {
                  setmodelTransaction((prev) => ({ ...prev, date }));
                }}
              />
            </Responsive>
            <Responsive m={4} l={4} xl={4} className="p-5">
              <label></label>
              <IconButton
                onClick={saveTransaction}
                color="violet"
                icon={<PlusRoundIcon />}
              ></IconButton>
            </Responsive>
            <Grid
              deleteAction={deleteAction}
              dataKey="id"
              rows={model.transactions}
              columns={[
                {
                  name: "Date",
                  value: "date",
                  render: (v) => <b> {moment(v).format("DD MMM YYYY")}</b>,
                },
                {
                  value: "debit",
                  name: "Débit",
                  render: (v) => (
                    <b style={{ fontSize: "14px", color: "#549f0a" }}>
                      {v ? format_number(v) : ""}
                    </b>
                  ),
                },
              ]}
            />
          </div>
        ))}
      {model.status != 1 && (
        <>
          <Responsive l={6} xl={6} className="p-5">
            <label>Date De Changement: </label>
            <Input
              defaultValue={moment(model.changeDate).format("YYYY-MM-DD")}
              type="date"
              value={moment(model.changeDate).format("YYYY-MM-DD")}
              onChange={(changeDate) =>
                _setmodel((prev) => {
                  return { ...prev, changeDate };
                })
              }
              block
            />{" "}
          </Responsive>
          <Responsive l={6} xl={6} className="p-5">
            <label>Numéro de bordereau: </label>
            <Input
              value={model.payingInSlip}
              onChange={(payingInSlip) =>
                _setmodel((prev) => {
                  return { ...prev, payingInSlip };
                })
              }
              block
            />{" "}
          </Responsive>
        </>
      )}

      <Responsive l={6} xl={6} className="p-5">
        <label>Montant</label>
        <Input
          type="number"
          disabled={inset}
          step="0.1"
          value={model.amount}
          onChange={(amount) => {
            _setmodel((prev) => {
              return { ...prev, amount };
            });
          }}
        />
      </Responsive>
      <Responsive l={6} xl={6} className="p-5">
        <label>Tireur / Proprietaire</label>
        <Input
          value={model.owner}
          onChange={(owner) => {
            _setmodel((prev) => {
              return { ...prev, owner };
            });
          }}
        />
      </Responsive>
      {typeof clients != "undefined" && (
        <>
          <Responsive l={6} xl={6} className="p-5">
            <label>Client: </label>
            <SelectPicker
              data={[{ label: "Tout", value: null }].concat(
                clients.map((c) => {
                  return { label: c.name, value: c.id };
                })
              )}
              block
              noSearch
              value={model.clientId}
              onSelect={(clientId) => {
                _setmodel((prev) => {
                  return { ...prev, clientId };
                });
              }}
            />
          </Responsive>
          {clients.find((c) => c.name.includes("(B2C)")) && (
            <Responsive l={6} xl={6} className="p-5">
              <label>Client B2C</label>
              <Input
                value={model.b2CName}
                onChange={(b2CName) => {
                  _setmodel((prev) => {
                    return { ...prev, b2CName };
                  });
                }}
              />
            </Responsive>
          )}
        </>
      )}
      <Responsive l={6} xl={6} className="p-5">
        {" "}
        <label>Banque d'Emission: </label>
        <SelectPicker
          onSearch={(q) => fetchBanks(q)}
          data={[{ label: "Tout", value: 0 }].concat(banks)}
          block
          noSearch
          value={model.emmissionBankId}
          onSelect={(emmissionBankId) => {
            _setmodel((prev) => {
              return { ...prev, emmissionBankId };
            });
          }}
        />
      </Responsive>
      <Responsive l={6} xl={6} className="p-5">
        <label>Banque de Dépôt: </label>
        <SelectPicker
          onSearch={(q) => fetchBanks(q)}
          data={[{ label: "Tout", value: 0 }].concat(banks)}
          block
          noSearch
          value={model.depositBankId}
          onSelect={(depositBankId) => {
            _setmodel((prev) => {
              return { ...prev, depositBankId };
            });
          }}
        />
      </Responsive>
      <Responsive l={6} xl={6} className="p-5">
        <label>Date De Dépôt: </label>
        <Input
          type="date"
          defaultValue={moment(model.date).format("YYYY-MM-DD")}
          value={moment(model.date).format("YYYY-MM-DD")}
          onChange={(date) =>
            _setmodel((prev) => {
              return { ...prev, date };
            })
          }
          block
        />
      </Responsive>
      <Responsive l={6} xl={6} className="p-5">
        <label>Date D'échèance: </label>
        <Input
          type="date"
          defaultValue={moment(model.dueDate).format("YYYY-MM-DD")}
          value={moment(model.dueDate).format("YYYY-MM-DD")}
          onChange={(dueDate) =>
            _setmodel((prev) => {
              return { ...prev, dueDate };
            })
          }
          block
        />
      </Responsive>
      <Responsive l={6} xl={6} className="p-5">
        {typeof clients != "undefined" && (
          <>
            <label>Type </label>
            <SelectPicker
              searchable={false}
              data={checkPurpose}
              block
              noSearch
              value={model.checkPurpose}
              onSelect={(checkPurpose) => {
                _setmodel((prev) => {
                  return { ...prev, checkPurpose };
                });
              }}
            />
          </>
        )}
      </Responsive>
      <label>Notes:</label>
      <Input
        as="textarea"
        rows={3}
        placeholder="Textarea"
        value={model.notes}
        onChange={(notes) => {
          _setmodel((prev) => {
            return { ...prev, notes };
          });
        }}
      />
      <label>Attachement:</label>
      <Uploader
        loading={loadingAttach}
        autoUpload={false}
        fileList={attachments}
        action="#"
        draggable
        onRemove={(f) => _delete(f.fileKey)}
        onChange={(list) => {
          // setstate((prev) => list);
          let file = list.filter((el) => el.status != "finished").reverse()[0];
          if (file) upload(list, file.blobFile, file.fileKey);
        }}
      >
        <div style={{ background: "rgba(200,200,200,0.1)" }}>
          <div style={{ fontSize: "50px" }}>
            {" "}
            <FileUploadIcon color="#3598ff"></FileUploadIcon>
          </div>
          <h4 style={{ color: "#bbb", fontWeight: "400" }}>
            Clicker ou Faites glisser les fichiers vers cette zone
            {/* pour les télécharger */}
          </h4>
        </div>
      </Uploader>
      <br></br>
      {error && (
        <Message showIcon type="error">
          {error}
        </Message>
      )}
    </>
  );
}

export default AddEditCheck;
